// extracted by mini-css-extract-plugin
export default {"container":"LeadStatusWithIcon_container__OHSDT","icon":"LeadStatusWithIcon_icon__OTl0r"};